'use strict';
module.exports = require('./Card.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/card/index.js
// module id = 44
// module chunks = 1